import { Card, message, notification, Space, Spin, Steps } from "antd";
import React, { SetStateAction, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { ArticleProperties } from "../../../types/blog.type";
import useBreadcrumbs from "../../../hooks/useBreadcrumbs";
import useAuth from "../../../hooks/useAuth";
import { successModal } from "../../../helpers/modal";
import { httpRequest } from "../../../helpers/api";
import { getErrorMessage } from "../../../helpers/errorHandler";
import TitleSection from "../../../components/TitleSection";
import CreateDetailPost from "./CreateComponents/DetailPost";
import CreateDescriptionPost from "./CreateComponents/DescriptionPost";
import { BaseResponseProps } from "../../../types/config.type";
import { UserProperties } from "../../../types/user.type";

export const MAPPING_STEP = {
	"detail-post": 0,
	"description-post": 1,
};
interface RouterParams {
	articleId?: string;
	index?: keyof typeof MAPPING_STEP;
}
interface CreatePostProps {
	isEdit?: boolean;
}
export interface PostStepProps {
	articleId?: string;
	post?: ArticleProperties;
	setPost: (value: ArticleProperties) => void;
	isEdit?: boolean;
}
type LocationState = {
	isSuccess?: boolean;
};
const CreatePost: React.FC<CreatePostProps> = ({ isEdit }) => {
	const { setBreadcrumb } = useBreadcrumbs();
	const history = useHistory();
	const { state } = useLocation<LocationState>();
	const [isLoading, setIsLoading] = useState(false);
	const [post, setPost] = useState<ArticleProperties>();
	const { articleId, index = "detail-post" } = useParams<RouterParams>();

	useEffect(() => {
		if (state?.isSuccess) {
			setPost(undefined);
			successModal({
				title: "Post Created",
				subtitle: "Your post is created!",
				onOk: () => {
					history.replace("/blog-posts");
				},
			});
		} else {
			let abortController = new AbortController();
			if (articleId) {
				(async () => {
					try {
						setIsLoading(true);
						let { data } = await httpRequest.get<BaseResponseProps<ArticleProperties>>(
							"/articles/" + articleId,
							{
								signal: abortController.signal,
							}
						);
						let { data: dataUser } = await httpRequest.get<BaseResponseProps<UserProperties>>(
							"/users/" + data.payload.createdByUserId
						);
						if (data) {
							let bc = [
								{
									label: data.payload.title,
									origin: articleId,
								},
							];
							setBreadcrumb(bc);
							setPost({
								...data.payload,
								user: dataUser?.payload,
							});
							setIsLoading(false);

							console.log("fetched");
						}
					} catch (err) {
						message.error(getErrorMessage(err));
					} finally {
						setIsLoading(false);
					}
				})();
			}
		}

		// eslint-disable-next-line
	}, [articleId, index]);

	const stepProps: PostStepProps = {
		articleId,
		post,
		setPost,
		isEdit,
	};

	return (
		<React.Fragment>
			<TitleSection
				title={isEdit ? "Edit Post" : "Create Post"}
				icon="back"
			/>
			<Spin spinning={isLoading}>
				<Card
					bordered={false}
					size="small"
				>
					<Space direction="vertical">
						<div className="ant-steps-divider">
							<Steps
								current={MAPPING_STEP[index]}
								style={{ maxWidth: 500 }}
								items={[{ title: "Post Detail" }, { title: "Post Description" }]}
							/>
						</div>
						{index === "detail-post" ? (
							<CreateDetailPost {...stepProps} />
						) : index === "description-post" ? (
							<CreateDescriptionPost {...stepProps} />
						) : (
							<React.Fragment />
						)}
					</Space>
				</Card>
			</Spin>
		</React.Fragment>
	);
};
export default CreatePost;
